export const status = {
  OLD: 'OLD',
  NEWS: 'NEW',
  LICENSE_EXPIRED: 'LICENSE_EXPIRED',
  ALL: 'ALL',
  LEAVE: 'LEAVE',
}

export const statusText = {
  OLD: 'พนักงานเก่า',
  NEWS: 'ปกติ',
  LICENSE_EXPIRED: 'ใบขับขี่หมดอายุ',
  ALL: 'ทั้งหมด',
  LEAVE: 'ลางาน',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}
